import calendarContextMenuComponent from './calendarContextMenu.component';

let calendarContextMenuModule = angular.module('vacations-absences.calendarContextMenu', [])

.component('calendarContextMenu', calendarContextMenuComponent)

.name;

export default calendarContextMenuModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/calendarContextMenu/calendarContextMenu.js